import { get, post } from '@utils/request';

// 活动详情
export const getCooperationActivity = params => get('cooperation/getCooperationActivity', params);

// 集卡信息
export const queryCardInfo = params => get('cooperation/getCard', params);

// 领取权益
export const getCrispyRiceReceive = data => post('cooperation/receive', data);

// 获取用户昵称
export const queryUserNickname = params => get('user/getUserInfoByUid', params);



